/* @flow */
import * as React from 'react';

import cx from 'classnames';

import './styles/SettingsContainer.scss';

class SettingsContainer extends React.Component<$FlowFixMeProps> {
  render() {
    return (
      <div {...this.props} className={cx('SettingsContainer', this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}

export default SettingsContainer;
